<template>
  <section id="orcamento" class="py-6 text-sky-700">
    <div class="main-container mx-auto max-w-screen-xl sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 gap-x-16 gap-y-8 lg:grid-cols-7">
            <div class="lg:col-span-2 lg:justify-self-end items-center lg:mt-16">
                <div>
                    <h2 class="text-center text-4xl font-bold tracking-tight sm:text-4xl whitespace">
                        Redes Sociais
                    </h2>
                    <p>
                        <span class="text-xs tracking-wide text-gray-500 uppercase">
                        Telefone para contato
                        </span>

                        <a href="tel:+551432343097" class="block text-2xl font-medium text-gray-900 hover:opacity-75 sm:text-3xl">
                        (14) 3234-3097
                        </a>
                    </p>

                    <ul class="mt-8 space-y-1 text-sm text-gray-700">
                        <li>Segunda a Sexta: 8:00 - 18:00 horas</li>
                        <li>Sábado: 8:00  - 12:00</li>
                    </ul>
                </div>

                <ul class="flex justify-center gap-6 mt-8 items-center">

                    <a href="https://www.facebook.com/planetapiscinasbauru/" rel="noreferrer" target="_blank" class="text-gray-700 transition hover:opacity-75">
                        <span class="sr-only">Facebook</span>

                        <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fill-rule="evenodd"
                            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                            clip-rule="evenodd" />
                        </svg>
                    </a>

                    <a href="https://www.instagram.com/planetapiscinasbauruoficial/" rel="noreferrer" target="_blank" class="text-gray-700 transition hover:opacity-75">
                        <span class="sr-only">Instagram</span>

                        <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fill-rule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clip-rule="evenodd" />
                        </svg>
                    </a>

                    <a href="https://www.youtube.com/channel/UCduip5dgcsgRIAWp0-0_4Nw" rel="noreferrer" target="_blank" class="opacity-75 hover:opacity-50">
                        <span class="sr-only">Youtube</span>
                        <svg class="w-8 h-8" viewBox="5.368 5.414 53.9 53.9" xmlns="http://www.w3.org/2000/svg"><path fill="#FFF" d="M41.272 31.81c-4.942-2.641-9.674-5.069-14.511-7.604v15.165c5.09-2.767 10.455-5.301 14.532-7.561h-.021z"/><path fill-rule="evenodd" d="M41.272 31.81c-4.942-2.641-14.511-7.604-14.511-7.604l12.758 8.575c.001 0-2.324 1.289 1.753-.971z"/><path fill-rule="evenodd" d="M27.691 51.242c-10.265-.189-13.771-.359-15.926-.803-1.458-.295-2.725-.95-3.654-1.9-.718-.719-1.289-1.816-1.732-3.338-.38-1.268-.528-2.323-.739-4.9-.323-5.816-.4-10.571 0-15.884.33-2.934.49-6.417 2.682-8.449 1.035-.951 2.239-1.563 3.591-1.816 2.112-.401 11.11-.718 20.425-.718 9.294 0 18.312.317 20.426.718 1.689.317 3.273 1.267 4.203 2.492 2 3.146 2.035 7.058 2.238 10.118.084 1.458.084 9.737 0 11.195-.316 4.836-.57 6.547-1.288 8.321-.444 1.12-.823 1.711-1.479 2.366a7.085 7.085 0 0 1-3.76 1.922c-8.883.668-16.426.813-24.987.676zM41.294 31.81c-4.942-2.641-9.674-5.09-14.511-7.625v15.166c5.09-2.767 10.456-5.302 14.532-7.562l-.021.021z"/></svg>
                    </a>
                </ul>
            </div>

            <div class="hidden lg:block lg:col-span-1">

            </div>
            
            <div class="p-8 bg-white shadow lg:p-12 lg:col-span-4 relative">
                <nav class="flex p-1 mb-8 text-gray-400 rounded-lg bg-gray-50">
                    <ol class="inline-flex items-center space-x-1 md:space-x-3">
                        <li aria-current="page">
                        <div class="flex items-center">
                            <span class="ml-10 text-sm font-medium text-gray-400 md:ml-2">
                                Faça um orçamento
                            </span>
                        </div>
                        </li>
                    </ol>
                </nav>
                <form action="" class="space-y-4"  @submit.prevent="submitOrçamento($event)">
                    <div>
                        <label class="sr-only" for="nome">Nome</label>
                        <input v-model="nome" class="w-full p-3 h-10 text-sm border text-gray-800 border-gray-200 focus:outline-none focus:border-blue-400" placeholder="Nome Completo" type="text" required @keydown.enter.stop.prevent/>
                    </div>

                    <div>
                        <label class="sr-only" for="telefone">telefone</label>
                        <input v-model="telefone" id="telefone" class="w-full p-3 h-10 text-sm border text-gray-800 border-gray-200 focus:outline-none focus:border-blue-400" placeholder="(00) 00000-0000" type="tel" maxlength="15" pattern="\(\d{2}\)\s*\d{5}-\d{4}" required @keydown.enter.stop.prevent/>
                    </div>
                  
                       
                    <div v-if="buscando != 'outros'">
                        <label for="small-range" class="block mb-2 text-sm font-medium text-gray-900">Piscina de {{tamanho}} metros</label>
                        <input v-model="tamanho" type="range" max="15" min="2" step="0.1" class="form-range w-full h-1 mb-6 bg-gray-200 appearance-none cursor-pointer range-sm">
                    </div>

                    <div>
                        <ul class="grid gap-2 sm:gap-6 w-full md:grid-cols-4">
                            <li>
                                <input type="radio" v-model="buscando" id="alvenaria" value="piscina de Alvenaria" class="hidden peer" required >
                                <label for="alvenaria" class="inline-flex justify-center items-center py-2 sm:py-5 px-2 sm:h-16 w-full text-gray-500 bg-white border border-gray-200 cursor-pointer peer-checked:border-blue-400 hover:text-gray-600 peer-checked:text-gray-600 hover:bg-gray-50">                           
                                    <div class="block">             
                                        <div class="sm:w-full sm:font-semibold text-sm sm:text-base text-center">Alvenaria</div>
                                    </div>
                                </label>
                            </li>
                            <li>
                                <input type="radio" v-model="buscando" id="vinil" value="piscina de Vinil" class="hidden peer">
                                <label for="vinil" class="inline-flex justify-center items-center py-2 sm:py-5 px-2 sm:h-16 w-full text-gray-500 bg-white border border-gray-200 cursor-pointer peer-checked:border-blue-400 hover:text-gray-600 peer-checked:text-gray-600 hover:bg-gray-50">         
                                    <div class="block">
                                        <div class="sm:w-full sm:font-semibold text-sm sm:text-base text-center">Vinil</div>
                                    </div>
                                </label>
                            </li>
                            <li>
                                <input type="radio" v-model="buscando" id="manta" value="piscina de Manta Armada" class="hidden peer">
                                <label for="manta" class="inline-flex justify-center items-center py-2 sm:py-5 px-2 sm:h-16 w-full text-gray-500 bg-white border border-gray-200 cursor-pointer peer-checked:border-blue-400 hover:text-gray-600 peer-checked:text-gray-600 hover:bg-gray-50">         
                                        <div class="sm:w-full sm:font-semibold text-sm sm:text-base text-center">Manta Armada</div>
                                </label>
                            </li>
                            <li>
                                <input type="radio" v-model="buscando" id="outros" value="outros" class="hidden peer">
                                <label for="outros" class="inline-flex justify-center items-center py-2 sm:py-5 px-2 sm:h-16 w-full text-gray-500 bg-white border border-gray-200 cursor-pointer peer-checked:border-blue-400 hover:text-gray-600 peer-checked:text-gray-600 hover:bg-gray-50">         
                                    <div class="block">
                                        <div class="sm:w-full sm:font-semibold text-sm sm:text-base text-center">Outros</div>
                                    </div>
                                </label>
                            </li>
                        </ul>
                    </div>

                    <div v-if="buscando == 'outros'">
                        <label class="sr-only" for="descricao">Descrição</label>
                        <textarea v-model="descricao" class="w-full p-3 text-sm text-gray-800 border border-gray-200 focus:outline-none focus:border-blue-400" placeholder="Descreva brevemente o que está buscando ..." rows="3" id="descricao"></textarea>
                    </div>

                    <div class="mt-10">
                        <button :disabled="btn_submit_disabled" type="submit" class="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-medium text-white bg-[rgb(68,173,58)] hover:bg-[rgb(20,146,73)] transition">
                            <svg class="h-7 w-7 mr-5" fill="#ffffff" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 308 308" xml:space="preserve" stroke="#ffffff" stroke-width="0"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_iconCarrier"> <g id="XMLID_468_"> <path id="XMLID_469_" d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156 c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687 c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887 c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153 c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348 c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802 c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922 c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0 c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458 C233.168,179.508,230.845,178.393,227.904,176.981z"/> <path id="XMLID_470_" d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716 c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396 c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188 l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677 c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867 C276.546,215.678,222.799,268.994,156.734,268.994z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </g></svg>
                            <span class="font-medium"> Solicitar via WhatsApp</span>
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 ml-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </button>

                    </div>
                </form>
             
            </div>
        </div>
    </div>
</section>
</template>

  
<script>
  export default {
    data(){
      return {
        tamanho: 6,

        feedbacks: null,
        acoes: null,
        nome: "",
        telefone: "",
        buscando: "piscina de Alvenaria",
        link: "",
        data: "",
        idAutor: [],
        idDisciplina: null,
        status: "A",
        descricao: "",

        disciplina: [],
        autores: [],
        msg: "",
        success: null,
        btn_submit_disabled: false,
        projeto:null
      }
    },
    methods: {
      async getFeedbacks() {
        const req = await fetch(`${process.env.VUE_APP_URL}/feedback`);
        const data = await req.json();

        this.feedbacks = data;
      },

      async submitOrçamento(e) {
        e.preventDefault();

        try {
            var today = new Date();
            today.setHours(today.getHours() - 3);

            const data = {
                nome: this.nome,
                telefone: this.telefone,
                buscando: this.buscando,
                tamanho: this.tamanho,
                descricao: this.descricao,
                data: today
            };
            const dataJson = JSON.stringify(data);

            await fetch(`${process.env.VUE_APP_URL}/orcamentos`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: dataJson
            });

            this.btn_submit_disabled = true;

            const num_empresa = 5514991181689;
            if(this.buscando != "outros") {
                var msg = encodeURI(`
                    Gostaria de solicitar um orçamento para uma ${this.buscando} de ${this.tamanho}.
                    Vocês poderiam me enviar mais informações e modelos.
                    Agradeço pela atenção e aguardo pelo retorno.
                    Att, ${this.nome}`);
            } else {
                var msg = encodeURI(`
                    ${this.descricao}.
                    Att, ${this.nome}`);
            }
                    
            window.open(`https://wa.me/${num_empresa}?text=${msg}`);

            this.btn_submit_disabled = false;
        }catch(e){
            console.log(`Error trying to register an budget: ${e}`);
        }

       
      }
    },
    watch: {
      async telefone() {
        this.telefone = this.telefone.replace(/\D/g, "");
        this.telefone = this.telefone.replace(/^(\d{2})(\d)/g, "($1) $2");
        this.telefone = this.telefone.replace(/(\d)(\d{4})$/, "$1-$2");
      },
    },
    mounted() {
      this.getFeedbacks()
    }
  }
   
   
</script>

<style scoped>
</style>




